import Calendar from "../../components/Calendar.tsx";

export default function CalendarPage() {
  return (
    <div>
      <Calendar />
    </div>
  );
}
